import {
    RECEIVE_BLACKLIST,
    RECEIVE_BLACKLIST_ERROR,
    RECEIVE_SAVE_BLACKLIST,
    RECEIVE_SAVE_BLACKLIST_ERROR,
    REQUEST_BLACKLIST,
    REQUEST_SAVE_BLACKLIST,
} from '../actions/blacklist';

const initState = {
    isFetching: false,
    fetched: false,
    isError: false,
    isSaving: false,
    saved: false,
    readTime: null,
    lastUpdated: null,
};

export default function blacklist(state = initState, action) {
    switch (action.type) {
        case REQUEST_BLACKLIST:
            return {
                ...state,
                [action.code]: {
                    isFetching: true,
                    fetched: false,
                    isError: false,
                },
            };
        case RECEIVE_BLACKLIST:
            return {
                ...state,
                isFetching: false,
                fetched: true,
                isError: false,
                blacklist: action.blacklist,
                readTime: action.readTime,
                lastUpdated: action.receivedAt,
            };
        case RECEIVE_BLACKLIST_ERROR:
            console.error(action.error);
            return {
                ...state,
                isFetching: false,
                fetched: true,
                isError: true,
                error: action.error.toString(),
            };
        case REQUEST_SAVE_BLACKLIST:
            return {
                ...state,
                isSaving: true,
                saved: false,
                isError: false,
            };
        case RECEIVE_SAVE_BLACKLIST:
            return {
                ...state,
                isSaving: false,
                saved: true,
                isError: false,
                lastUpdated: action.receivedAt,
            };
        case RECEIVE_SAVE_BLACKLIST_ERROR:
            console.error(action.error);
            return {
                ...state,
                isSaving: false,
                saved: true,
                isError: true,
                error: action.error.toString(),
            };
        default:
            return state;
    }
}